/**
 * The encounter's **map ground** (`terrain-tile-art` ruling 8): the surface every cell with no tile
 * of its own is painted as. A short closed list, set by the GM with `set_ground`; an unset
 * encounter paints {@link DEFAULT_ENCOUNTER_GROUND}. Art only: the ground has no mechanics, so no
 * rule reads it.
 */
export type EncounterGround = "forest-floor" | "dust" | "deck";

/** Every {@link EncounterGround}, with a display label for the TERRAIN window's picker. */
export const ENCOUNTER_GROUNDS: readonly { value: EncounterGround; label: string }[] = [
  { value: "forest-floor", label: "Forest floor" },
  { value: "dust", label: "Dust" },
  { value: "deck", label: "Deck" },
];

/** The ground an encounter with none set paints. */
export const DEFAULT_ENCOUNTER_GROUND: EncounterGround = "forest-floor";

/** Whether a string is a known {@link EncounterGround}. */
export function isEncounterGround(v: string): v is EncounterGround {
  return ENCOUNTER_GROUNDS.some((g) => g.value === v);
}
